import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { IncometaxService } from '../../Model/Incometax/incometax.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { EmployeeListPopupComponent } from '../../Component/employee-list-popup/employee-list-popup.component';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-admin-tax-user-list',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, RouterOutlet, RouterModule, NgbDatepickerModule, NgSelectModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './admin-tax-user-list.component.html',
  styleUrl: './admin-tax-user-list.component.scss'
})
export class AdminTaxUserListComponent {
  isDisabled: boolean = false;
  FinancialYears: any[] = [];
  TaxDatas: any[] = [];

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    SelectType: '',
    ESS_EmpTaxDeclarationID: 0,
    ESS_EmpTaxInvestmentID: 0,
    EmpMasterId: null,
    FinancialYearFrom: '',
    FinancialYearFromObj: '',
    FinancialYearTo: '',
    FinancialYearToObj: '',
    IsDraft: true,
    ApprovalStatus: 'Approved',
    ModuleMasterId: 9,
    ESS_TaxFinancialYearID: null,
    TaxType: true,
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    private session: SessionService,
    protected dateFormat: CustomDateParserFormatter,
    private toast: ToastService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_TaxFinancialYearSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if (this.Filter.ESS_TaxFinancialYearID == null || this.Filter.ESS_TaxFinancialYearID == 0) {
        this.Filter.FinancialYearFrom = '';
        this.Filter.FinancialYearTo = '';
      } else {
        this.Filter.FinancialYearFrom = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
        this.Filter.FinancialYearTo = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
      }

      if (this.Filter.TaxType) {
        this.ESS_EmpTaxDeclarationSelect();
      } else {
        this.ESS_EmpTaxInvestmentSelect();
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });

          this.Filter.ESS_TaxFinancialYearID = this.FinancialYears.filter(e => e.IsActive)[0].ESS_TaxFinancialYearID;
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxDeclarationSelect() {
    this.isDisabled = true;
    this.Filter.SelectType = 'S';
    this.incometax.ESS_EmpTaxDeclarationSelect(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TaxDatas = Object.values(response.Table);
        } else {
          this.TaxDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxInvestmentSelect() {
    this.isDisabled = true;
    this.Filter.SelectType = 'E';
    this.incometax.ESS_EmpTaxInvestmentSelect(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TaxDatas = Object.values(response.Table);
        } else {
          this.TaxDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.TaxDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  OpenUserList() {
    const modalRef = this.modalService.open(EmployeeListPopupComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.result.then((result) => {

    });
  }

  Delete(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result) => {
      if (result) {
        if (this.Filter.TaxType) {
          this.ESS_EmpTaxDeclaration_InsertUpdate(this.TaxDatas[index].ESS_EmpTaxDeclarationID, index);
        } else {
          this.ESS_EmpTaxInvestment_InsertUpdate(this.TaxDatas[index].ESS_EmpTaxInvestmentID);
        }
      }
    });
  }

  async ESS_EmpTaxDeclaration_InsertUpdate(ESS_EmpTaxDeclarationID: number, index: number) {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxDeclaration_InsertUpdate({
      SelectType: 'AdminDelete', ESS_EmpTaxDeclarationID: ESS_EmpTaxDeclarationID, IsAdminEntry: true,
      FinancialYearStart: this.TaxDatas[index].FinancialYearStart, FinancialYearEnd: this.TaxDatas[index].FinancialYearEnd, EmpMasterId: this.TaxDatas[index].EmpMasterId
    }).subscribe({
      next: async (response) => {
        if (response.Error_Code == '744') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            this.ESS_EmpTaxDeclarationSelect();
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_EmpTaxInvestment_InsertUpdate(ESS_EmpTaxInvestmentID: number) {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestment_InsertUpdate({ SelectType: 'AdminDelete', ESS_EmpTaxInvestmentID: ESS_EmpTaxInvestmentID, IsAdminEntry: true, }).subscribe({
      next: async (response) => {
        if (response.Error_Code == '744') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            this.ESS_EmpTaxInvestmentSelect();
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ExcelDump() {
    if (this.TaxDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TaxDatas, 'Tax Declaration Data')
    }
  }
}